import { jsx } from "react/jsx-runtime";
function StylePanelSubheading({ children }) {
  return /* @__PURE__ */ jsx("h3", { className: "tlui-style-panel__subheading", children });
}
export {
  StylePanelSubheading
};
//# sourceMappingURL=StylePanelSubheading.mjs.map
